import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Router, NavigationStart, NavigationExtras } from '@angular/router';
import { Tooltip } from 'bootstrap';

@Injectable({ providedIn: 'root' })
export class RouteTransitionDirectionService {
  private renderer: Renderer2;
  private lastDir: SlideDirection | null = null;

  constructor(
    private readonly router: Router,
    rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.listen();
  }

  private listen() {
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationStart) {
        const nav = this.router.getCurrentNavigation();
        const dir = nav?.extras?.state?.['slideDir'];
        if (dir === 'Left' || dir === 'Right' || dir === 'Up' || dir === 'Down') {
          this.apply(dir);
        } else {
          this.clear();
        }
      }
    });
  }

  private apply(dir: SlideDirection) {
    if (this.lastDir) {
      this.renderer.removeClass(document.documentElement, `transition-${this.lastDir.toLowerCase()}`);
    }
    this.renderer.addClass(document.documentElement, `transition-${dir.toLowerCase()}`);
    this.lastDir = dir;
  }

  private clear() {
    if (this.lastDir) {
      this.renderer.removeClass(document.documentElement, `transition-${this.lastDir.toLowerCase()}`);
      this.lastDir = null;
    }
  }
}

export function disposeAllTooltips() {
  const triggerEls = document.querySelectorAll('[data-bs-toggle="tooltip"], [certTooltip]');
  triggerEls.forEach((el) => {
    try {
      const inst = Tooltip.getInstance(el as HTMLElement);
      if (inst) {
        inst.dispose();
        if ((inst as any)._activeTrigger) {
          (inst as any)._activeTrigger = {};
        }
      }
    } catch {}
  });
}

export function disposeTooltipsInContainer(container: HTMLElement) {
  const triggerEls = container.querySelectorAll('[data-bs-toggle="tooltip"], [certTooltip]');
  triggerEls.forEach((el) => {
    try {
      const inst = Tooltip.getInstance(el as HTMLElement);
      if (inst) {
        inst.dispose();
        if ((inst as any)._activeTrigger) {
          (inst as any)._activeTrigger = {};
        }
      }
    } catch {}
  });
}

export function navigateWithSlide(router: Router, commands: any[], dir: SlideDirection, extras?: NavigationExtras) {
  disposeAllTooltips();
  return router.navigate(commands, {
    ...extras,
    state: { ...(extras?.state ?? {}), slideDir: dir },
  });
}

export enum SlideDirection {
  Left = 'Left',
  Right = 'Right',
  Down = 'Down',
  Up = 'Up',
}
